import RoomInfo from "./RoomInfo";
import BuildingInfo from "./BuildingInfo";

export default function InfoCards({ dataItems }) {
  return <>{dataItems.map((data) => renderCard(data))}</>;
}

function renderCard(data) {
  if (data.type === "building") {
    return (
      <BuildingInfo
        building={data}
        key={data.id || data.bldrecnbr}
      ></BuildingInfo>
    );
  } else if (data.type === "room" || data.type === "label") {
    // On touch-devices, touching label text (in a room) causes type
    // to be 'label' instead of 'room' so we test for both here.
    return <RoomInfo room={data} key={data.id || data.rmrecnbr}></RoomInfo>;
  }
}
